import { Spinner } from "@kamae-apps/shared/Components/Atoms/Spinner/Spinner"
import { FC } from "react"
import style from "./PageLoader.module.css"

export const PageLoader: FC = () => {
  return (
    <div
      className={style["loader-container"]}
      data-testid={"page-loader"}
    >
      <Spinner />
    </div>
  )
}
